export function parseDate(dateStr) {
    if (dateStr == undefined) return null;
    return new Date(dateStr);
}

export function dateComparator(date1, date2) {
    if (date1 == undefined && date2 == undefined) return 0;
    if (date1 == undefined) return -1;
    if (date2 == undefined) return 1;

    const dateObj1 = parseDate(date1);
    const dateObj2 = parseDate(date2);

    if (!dateObj1 || !dateObj1.isValid) return -1;
    if (!dateObj2 || !dateObj2.isValid) return 1;

    if (dateObj1.getTime() < dateObj2.getTime()) return -1;
    if (dateObj1.getTime() > dateObj2.getTime()) return 1;
    return 0;
}

export function sortTimes(a, b) {
    // Split time into hours and minutes
    const [hourA, minuteA] = a.split(':').map(Number);
    const [hourB, minuteB] = b.split(':').map(Number);

    // Compare hours first, then minutes if hours are the same
    if (hourA !== hourB) {
        return hourA - hourB;
    } else {
        return minuteA - minuteB;
    }
}
